// Permission catalogue (PERMISSION_MATRIX.md). Format `<domain>:<action>`. '*' = wildcard.
export const PERMISSIONS = {
  DASHBOARD_READ: 'dashboard:read',

  USERS_READ: 'users:read',
  USERS_WRITE: 'users:write',
  USERS_DELETE: 'users:delete',
  USERS_BLOCK: 'users:block',
  USERS_GRANT_PRO: 'users:grant_pro',
  USERS_EXPORT: 'users:export',

  CONTENT_READ: 'content:read',
  CONTENT_WRITE: 'content:write',
  CONTENT_DELETE: 'content:delete',
  CONTENT_PUBLISH: 'content:publish',
  CONTENT_ENRICH: 'content:enrich',
  CONTENT_EXPORT: 'content:export',

  SCRAPER_READ: 'scraper:read',
  SCRAPER_RUN: 'scraper:run',

  QUIZ_READ: 'quiz:read',
  QUIZ_WRITE: 'quiz:write',
  QUIZ_DELETE: 'quiz:delete',
  QUIZ_GENERATE: 'quiz:generate',

  MAINS_READ: 'mains:read',
  MAINS_WRITE: 'mains:write',
  MAINS_DELETE: 'mains:delete',

  AI_READ: 'ai:read',
  AI_MODERATE: 'ai:moderate',
  AI_SETTINGS: 'ai:settings',

  CATEGORIES_READ: 'categories:read',
  CATEGORIES_WRITE: 'categories:write',
  CATEGORIES_DELETE: 'categories:delete',

  EXAMS_READ: 'exams:read',
  EXAMS_WRITE: 'exams:write',
  EXAMS_DELETE: 'exams:delete',

  ALERTS_READ: 'alerts:read',
  ALERTS_WRITE: 'alerts:write',
  ALERTS_DELETE: 'alerts:delete',

  DOWNLOADS_READ: 'downloads:read',
  DOWNLOADS_WRITE: 'downloads:write',
  DOWNLOADS_DELETE: 'downloads:delete',

  BANNERS_READ: 'banners:read',
  BANNERS_WRITE: 'banners:write',
  BANNERS_DELETE: 'banners:delete',

  PAYMENTS_READ: 'payments:read',
  PAYMENTS_REFUND: 'payments:refund',
  PAYMENTS_RECONCILE: 'payments:reconcile',
  PAYMENTS_EXPORT: 'payments:export',

  SUBSCRIPTIONS_GRANT: 'subscriptions:grant',
  SUBSCRIPTIONS_REVOKE: 'subscriptions:revoke',

  COUPONS_READ: 'coupons:read',
  COUPONS_WRITE: 'coupons:write',
  COUPONS_DELETE: 'coupons:delete',

  NOTIFICATIONS_READ: 'notifications:read',
  NOTIFICATIONS_SEND: 'notifications:send',

  SETTINGS_READ: 'settings:read',
  SETTINGS_WRITE: 'settings:write',

  STAFF_READ: 'staff:read',
  STAFF_WRITE: 'staff:write',

  AUDIT_READ: 'audit:read',
};

export const WILDCARD = '*';
